<template>
    <yams-template>
        <template #header>
            <div class="mr-5">
                <h4 class="text-primary">Configurations</h4>
            </div>
        </template>
        <template #content>
            <div class="config-container">
                <div class="tabs-navigation">
                    <router-link :to="{ name: 'configurations.general' }" class="tab-link" active-class="tab-active">
                        <i class="fa-solid fa-sliders mr-2"></i>
                        <span>Configuration générale</span>
                    </router-link>
                    <router-link :to="{ name: 'configurations.vehicules' }" class="tab-link" active-class="tab-active">
                        <i class="fa-solid fa-truck mr-2"></i>
                        <span>Parametres des vehicules</span>
                    </router-link>
                    <router-link :to="{ name: 'configurations.interventions' }" class="tab-link"
                        active-class="tab-active">
                        <i class="fa-solid fa-wrench mr-2"></i>
                        <span>Parametres des interventions</span>
                    </router-link>
                    <router-link :to="{ name: 'configurations.courses' }" class="tab-link" active-class="tab-active">
                        <i class="fa-solid fa-road-bridge mr-2"></i>
                        <span>Parametres des courses</span>
                    </router-link>
                    <!-- <router-link :to="{name: 'configurations.general'}" class="tab-link" active-class="tab-active">
                        <i class="fa-solid fa-receipt mr-2"></i>
                        <span>Parametres des comptes</span>
                    </router-link> -->
                </div>
                <div class="content-panel">
                    <router-view />
                </div>
            </div>
        </template>
    </yams-template>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'IndexConfig',
});
</script>

<style scoped>
.config-container {
    max-width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.tabs-navigation {
    display: flex;
    background-color: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    padding: 0;
    overflow-x: auto;
}

.tab-link {
    color: #64748b;
    font-weight: 500;
    padding: 1rem 1.5rem;
    text-decoration: none;
    border-bottom: 2px solid transparent;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.tab-link:hover {
    color: #4f46e5;
    text-decoration: none;
}

.tab-active {
    color: #4f46e5;
    border-bottom: 2px solid #4f46e5;
    background-color: transparent;
}

.content-panel {
    padding: 1.5rem;
    min-height: 300px;
}

@media (max-width: 768px) {
    .tabs-navigation {
        flex-wrap: nowrap;
        overflow-x: auto;
    }

    .tab-link {
        font-size: 0.9rem;
        padding: 0.75rem 1rem;
    }
}
</style>